import { SdkMethodPayloadInterface } from "@modules/sdk/methods/SdkMethodPayloadInterface";

import { WISHLISTS_SDK_METHODS } from "../constants";
import { WishlistsStack } from "../stack/WishlistsStack";

class GetWishlistsStackSdkMethodPayload
    implements SdkMethodPayloadInterface<WishlistsStack>
{
    public readonly methodName: WISHLISTS_SDK_METHODS.GET_WISHLISTS_STACK;

    constructor(
        public readonly onSuccess: (result: WishlistsStack) => void,
        public readonly onError: (error: Error) => void
    ) {
        this.methodName = WISHLISTS_SDK_METHODS.GET_WISHLISTS_STACK;
        this.onSuccess = onSuccess;
        this.onError = onError;
    }
}

export default GetWishlistsStackSdkMethodPayload;
